import { useCallback, useEffect, useState } from "react";
import {
  prepareAppSettingsSchema,
  PreparedAppSettingsSchema,
} from "../components/AppSettingsSchema/context";
import { getAppSettingsSchema } from "../network";

export const useAppSettingsSchema = (): [
  PreparedAppSettingsSchema | null,
  boolean,
  Error | null,
] => {
  const [result, setResult] = useState<PreparedAppSettingsSchema | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  const request = useCallback(async () => {
    setIsLoading(true);
    setError(null);

    try {
      const schema = await getAppSettingsSchema();
      setResult(prepareAppSettingsSchema(schema));
    } catch (e) {
      if (e instanceof Error) {
        setError(e);
      } else {
        setError(new Error("Unknown error"));
      }
    }

    setIsLoading(false);
  }, []);

  useEffect(() => {
    request();
  }, [request]);

  return [result, isLoading, error];
};
